
export default function HowItWorks() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="how-it-works" className="py-24 bg-gradient-to-b from-[#FAF8F5] to-[#F5F0EB]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-5xl font-serif font-bold text-[#2B2B2B] mb-6">
              Streamlined Procurement, Simplified
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-8 max-w-xl">
              Design Assist transforms the complex procurement process into a seamless experience. From initial inquiry to the receiver, we handle every detail with precision and care, ensuring you receive the best products at the best prices without the hassle.
            </p>
            <p className="text-gray-600 text-lg leading-relaxed mb-10 max-w-xl">
              Our team works directly with manufacturers and distributors, leveraging our industry relationships to secure exclusive trade pricing and priority access for your projects.
            </p>

            <button
              onClick={() => scrollToSection('inquiry')}
              className="bg-[#C5A572] text-white px-8 py-4 rounded-full text-sm font-medium hover:bg-[#B8965F] transition-colors cursor-pointer whitespace-nowrap inline-flex items-center"
            >
              Learn Our Process
              <i className="ri-arrow-right-line ml-2"></i>
            </button>

            <div className="flex gap-20 mt-12">
              <div>
                <div className="text-7xl font-bold text-[#2B2B2B] mb-2">2000+</div>
                <div className="text-gray-600 text-sm">Products Available</div>
              </div>
              <div>
                <div className="text-7xl font-bold text-[#2B2B2B] mb-2">24HR</div>
                <div className="text-gray-600 text-sm">Average Turnaround</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/0d038b4e59f18b18de10592c483bd9b4.jpg"
                alt="Warehouse Operations"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute top-6 left-6 bg-white px-6 py-3 rounded-full shadow-lg flex items-center">
                <i className="ri-map-pin-line text-[#C5A572] mr-2"></i>
                <span className="text-sm font-medium text-[#2B2B2B]">Nationwide Shipping</span>
              </div>
              <div className="absolute bottom-6 left-6 right-6 bg-[#2B2B2B]/80 backdrop-blur-sm text-white px-6 py-4 rounded-2xl">
                <div className="font-medium">Factory to Warehouse</div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-24 grid md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-20 h-20 bg-[#C5A572] rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-search-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-[#2B2B2B] mb-3">1. Inquiry</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Submit your project requirements and product specifications through our simple inquiry form
            </p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 bg-[#D4BA8A] rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-price-tag-3-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-[#2B2B2B] mb-3">2. Sourcing</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              We source products from our extensive vendor network and secure the best trade pricing
            </p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 bg-[#2B2B2B] rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-truck-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-[#2B2B2B] mb-3">3. Coordination</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              We manage ordering, ETA updates, and shipping logistics from the factory to the receiver
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
